<template>
  <div :class="['title-bar', examLayoutV2 && 'title-bar--v2']">
    <div
      :class="[
        showRemainingTime &&
          type === 'exam' &&
          'title-bar__title-wrapper--show-time',
        (!showRemainingTime || type === 'quiz') &&
          'title-bar__title-wrapper--hide-time',
      ]"
    >
      <h4 class="title-bar__title">
        {{ examTitle }}
      </h4>
    </div>
    <div
      v-if="type === 'exam' && showRemainingTime && !examLayoutV2"
      class="title-bar__time-wrapper"
    >
      <TimerWidget :currentTime="currentTime" />
    </div>
    <div v-if="examLayoutV2" class="title-bar__btns">
      <button class="btn btn--tertiary" @click="$emit('close-modal')">
        Exit Exam
      </button>
      <button
        v-if="showSubmit"
        :class="[
          'btn submit-button',
          isLastQuestion ? 'btn--primary' : 'btn--secondary',
        ]"
        :disabled="!canSubmit"
        @click="$emit('submit')"
      >
        Submit Exam
      </button>
    </div>
    <XIcon
      v-if="!examLayoutV2"
      class="title-bar__close--mobile"
      @click="$emit('close-modal')"
    />
  </div>
</template>

<script>
import { XIcon } from 'vue-feather-icons'
import TimerWidget from '@/components/certifications/TimerWidget.vue'

export default {
  name: 'TitleBar',
  components: {
    TimerWidget,
    XIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    examLayoutV2: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
    type: {
      type: String,
      required: false,
      default() {
        return 'quiz'
      },
    },
    currentTime: {
      type: String,
      required: false,
    },
    showRemainingTime: {
      type: Boolean,
      require: false,
      default: true,
    },
    canSubmit: {
      type: Boolean,
      required: false,
      default: () => {
        return true
      },
    },
    currentStep: {
      type: String,
      required: false,
    },
    steps: {
      type: Object,
      required: false,
    },
    isLastQuestion: {
      type: Boolean,
      required: false,
    },
    showSubmit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      interval: null,
    }
  },
  computed: {
    examTitle() {
      if (this.type !== 'exam') return this.title
      if (this.examLayoutV2) return `${this.title} Certification Exam`
      return `CERTIFICATION EXAM: ${this.title}`
    },
  },
}
</script>

<style lang="scss" scoped>
.title-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  max-width: 2400px;
  z-index: 204;
  position: relative;
  background: transparent;
  padding: 20px;
  @include mobile {
    padding: 30px 20px 50px 20px;
  }
  &--v2 {
    background: var(--dark-brighter);
    padding: 15px 50px;
  }
  &__btns {
    display: flex;
    gap: 20px;
  }
  &__icon-wrapper {
    width: 50px;
    margin: 5px 0 0 0;
  }
  &__icon {
    width: 40px;
    &--cert {
      path {
        fill: var(--black);
      }
    }
  }
  &__title-wrapper {
    &--hide-time {
      width: 100%;
    }
    &--show-time {
      @include mobile {
        width: 50%;
      }
      @include desktop {
        width: 57%;
      }
    }
  }
  &__title {
    margin: 0;
    padding: 0;
    font-size: 1rem;
    line-height: 1.5rem;
    @include desktop {
      font-size: 22px;
      line-height: 2.5rem;
    }
  }
  &__data-wrapper {
    display: flex;
    margin-left: auto;
  }
  &__close {
    margin-left: 30px;
    cursor: pointer;
  }
}
</style>
